<script setup lang="tsx">
import { multiProps } from './props'
import type { Column } from '@/stores/column'
import ClearButton from './ClearButton.vue'
import { onBeforeUnmount, ref, watch } from 'vue'

const internalModel = ref<any | undefined>()
const model = defineModel<Column>({ required: true })
const props = defineProps(multiProps)

watch(internalModel, () => (model.value.filter = internalModel.value !== undefined ? [internalModel.value] : []))

watch(
	() => model.value.filter,
	(filter) => {
		internalModel.value = filter.length ? filter[0] : undefined
	},
	{ immediate: true },
)

onBeforeUnmount(() => (model.value.filter = []))
</script>

<template>
	<div class="w-100 position-relative d-inline-flex align-items-center">
		<select class="form-control" :id="props.id" :disabled="props.disabled" v-model="internalModel">
			<option disabled value="">{{ model.label + '...' }}</option>
			<option
				v-for="opt of props.options"
				:value="props.valueField ? opt[props.valueField] : opt"
				:key="props.valueField ? opt[props.valueField] : opt"
			>
				{{ props.labelField ? opt[props.labelField] : opt }}
			</option>
		</select>
		<span v-if="internalModel === undefined" class="placeholder2">{{ model.label + '...' }}</span>
		<ClearButton v-if="internalModel !== undefined" @click="internalModel = undefined"></ClearButton>
	</div>
</template>

<style lang="sass" scoped>
@import ~bootstrap/scss/functions
@import ~bootstrap/scss/variables

.placeholder2
  pointer-events: none
  position: absolute
  color: var(--bs-secondary-color)
  font-weight: $input-font-weight
  margin-left: .5em
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
  width: 100%
</style>
